import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/pages/ShowroomAdvantages/ShowroomAdvantages.styles';
import Icon from '@components/icons/Icon';
import sanitizeHtml from '@utils/sanitizeHtml';
import { IBlockAdditionalData } from '@features/cms/typescript';
type PropsType = {
  data: IBlockAdditionalData;
};
const ShowroomAdvantages = ({
  data
}: PropsType) => {
  const {
    t
  } = useTranslation('common');
  const handleSanitizeHtml = (key: string) => {
    const html = t(key);
    return sanitizeHtml(html || '');
  };
  return <div sx={styles.container} id={data.code} data-testid="ShowroomAdvantages">
      <div sx={styles.item} data-testid="ShowroomAdvantages-item">
        <Icon icon="FullInterior" size="64px" />
        <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.thousandsProducts')} />
      </div>
      <div sx={styles.item} data-testid="ShowroomAdvantages-item">
        <Icon icon="Users" size="64px" />
        <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.technicalAssistance')} />
      </div>
      <div sx={styles.item} data-testid="ShowroomAdvantages-item">
        <Icon icon="Coffee" size="44px" />
        <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.friendlyAtmosphere')} />
      </div>
      <div sx={styles.item} data-testid="ShowroomAdvantages-item">
        <Icon icon="Cubic" size="44px" />
        <p dangerouslySetInnerHTML={handleSanitizeHtml('showroomAdvantages.arrangementProgram')} />
      </div>
    </div>;
};
export default ShowroomAdvantages;